import React from "react";

const DownArrowIcon = (props) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.57391 8.81272V1.04248"
      stroke="white"
      stroke-width="1.38754"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.45728 4.92603L4.57216 8.81114L0.687041 4.92603"
      stroke="white"
      stroke-width="1.38754"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default DownArrowIcon;
